import { FaRegLightbulb, FiChevronRight, HiOutlineSparkles } from '@/components/react-icons/main';
import { openDocDrawer } from '@/redux/actions/uiActions/drawerActions.js'; // Importing the Input component
import * as Popover from '@radix-ui/react-popover';
import { cleanClass } from '@shared/utils/cleanClass.js';
import { useState } from 'react';
import Input from './Input.jsx';
import IconV2 from './v2/IconV2.jsx';
import { sendAiChatMessage } from '@/redux/actions/uiActions/aiChatActions.js';
import { useSelector } from 'react-redux';

const HelpIcon = ({ options, context = '', align = 'right', useAi = true, aiInputPlaceholder }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState(''); // State for input value

  const contextObject = useSelector((state) => state?.ui?.helpContextMap?.[context]);

  options = options ?? contextObject?.options;
  aiInputPlaceholder = aiInputPlaceholder ?? contextObject?.aiInputPlaceholder ?? 'Ask AI about this';

  const handleClick = (e, option) => {
    e.preventDefault();
    e.stopPropagation();
    if (option?.documentId) {
      handleOpenChange(false);
      openDocDrawer({ docId: option?.documentId, highlightedElementId: option?.documentHash });
    }
    setTimeout(() => {
      setIsOpen(false);
    }, 0);
  };

  const handleOpenChange = (open) => {
    setIsOpen(open);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value); // Update input value
  };

  const handleAiInputKeyPress = (e) => {
    if (e.key === 'Enter') {
      sendAiChatMessage(inputValue, { context: contextObject?.aiChatContext });
      setInputValue('');
    }
  };

  if (!options) {
    return null;
  }

  return (
    <Popover.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Popover.Trigger asChild>
        <div onClick={(e) => e.stopPropagation()}>
          <IconV2 icon={FaRegLightbulb} className={cleanClass(`help-icon ${isOpen ? 'active' : ''}`)} title={'Click for more information'} titleDelay={1000} />
        </div>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className={`help-icon-popover`} side={align} align={'center'} sideOffset={4} onClick={(e) => e.stopPropagation()}>
          {options?.map((option, index) => (
            <div className={`item ${!option?.documentId ? 'no-document' : ''}`} key={`${option?.documentId}-${index}`} onClick={(e) => handleClick(e, option)}>
              {option?.title && (
                <div className="header">
                  <h3>{option?.title}</h3>
                  {!!option?.documentId && (
                    <div className="header-actions">
                      <span className="learn-more">Learn More</span>
                      <IconV2 icon={FiChevronRight} className={'header-icon ghost'} />
                    </div>
                  )}
                </div>
              )}
              {!!option?.description && <p>{option?.description}</p>}
            </div>
          ))}
          {useAi && (
            <div className="ai-input-wrapper">
              <Input icon={HiOutlineSparkles} value={inputValue} onChange={handleInputChange} placeholder={aiInputPlaceholder} size="xs" className="borderless" onKeyPress={handleAiInputKeyPress} />
            </div>
          )}
          <Popover.Arrow className={'help-icon-popover-arrow'} />
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default HelpIcon;
